<template>
	<div class="category">
		<div class="peoples flex justify-around flex-wrap" v-show="tab == 'people'">
			<div class="item flex flex-direction align-center" v-for="(item, index) in peoples" :key="index" @click="detail(item.id, 'people', item)">
				<img :src="item.image" alt="" />
				<span>{{ item.title }}</span>
			</div>
			<div class="item" v-if="peoples.length > 1" v-for="(i, k) in leftFill(peoples.length, 2)" :key="'people_' + i"></div>
		</div>

		<div class="document flex  justify-around flex-wrap" v-show="tab == 'document'">
			<div class="item" v-for="(item, index) in documents" :key="index" @click="detail(item.id, 'document', item)">
				<img :src="item.image" alt="" />
				<span>{{ item.title }}</span>
			</div>
			<div class="item" v-if="documents.length > 1" v-for="(i, k) in leftFill(documents.length, 2)" :key="'document_' + i"></div>
		</div>
		<div class="media flex  justify-around flex-wrap" v-show="tab == 'media'">
			<div class="item" v-for="(item, index) in medias" :key="index" @click="detail(item.id, 'media', item)">
				<img v-if="item.image" :src="item.image" alt="" />
				<img class="audio" v-else-if="item.type_id == 3" src="../assets/images/audio.png" alt="" />
				<img class="video" v-else-if="item.type_id == 7" src="../assets/images/video.png" alt="" />
				<span>{{ item.title }}</span>
			</div>
			<div class="item" v-if="medias.length > 1" v-for="(i, k) in leftFill(medias.length, 2)" :key="'media_' + i"></div>
		</div>

		<div class="dialog-footer flex justify-around">
			<span :class="tab == 'people' ? 'active' : ''" @click="changeTab('people')">
				<img src="../assets/images/icon-people.png" alt="" style="height: 0.4rem;" />
				人物
			</span>
			<span :class="tab == 'document' ? 'active' : ''" @click="changeTab('document')">
				<img src="../assets/images/icon-document.png" alt="" style="height: 0.4rem;" />
				资料
			</span>
			<span :class="tab == 'media' ? 'active' : ''" @click="changeTab('media')">
				<img src="../assets/images/icon-media.png" alt="" style="height: 0.4rem;" />
				音视频
			</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		category: [String, Number]
	},
	data() {
		return {
			tab: 'people',
			peoples: [],
			documents: [],
			medias: []
		};
	},
	methods: {
		changeTab(tab) {
			this.tab = tab;
			this.updateTitle();
		},
		detail(id, type, data = {}) {
			this.$emit('detail', {
				id: id,
				type: type,
				data: data
			});
		},
		play(item) {},
		updateTitle() {
			if (this.tab == 'people') {
				this.$emit('update-title', '人物');
			} else if (this.tab == 'document') {
				this.$emit('update-title', '资料');
			} else if (this.tab == 'media') {
				this.$emit('update-title', '音视频');
			}
		}
	},
	mounted() {
		this.updateTitle();
		this.$loading.show();
		Promise.all([
			this.$api.get('/api/svc/cms/page/articles', { category_id: this.category, type_id: 8 }),
			this.$api.get('/api/svc/cms/page/articles', { category_id: this.category, 'type_id[in]': '2,6' }),
			this.$api.get('/api/svc/cms/page/articles', { category_id: this.category, 'type_id[in]': '3,7' })
		])
			.then(res => {
				this.$loading.hide();
				[this.peoples, this.documents, this.medias] = res;
			})
			.catch(err => {
				this.$loading.hide();
			});
	}
};
</script>

<style lang="scss" scoped>
.category {
	padding-bottom: 1rem;
}
.peoples {
	.item {
		width: 3rem;
		margin: 0.1rem 0;
		img {
			border-radius: 0.1rem;
			background-color: #d8d8d8;
			width: 3rem;
			height: 3rem;
		}
		span {
			font-size: 0.28rem;
			color: #d2d2d2;
			padding: 0.1rem;
		}
	}
}
.document,
.media {
	.item {
		margin-bottom: 0.1rem;
		width: 3rem;
		img {
			width: 3rem;
			height: 3rem;
			border-radius: 0.1rem;
			background-color: #fff;
		}
		span {
			text-align: center;
			color: #fff;
			font-size: 0.28rem;
			padding: 0.15rem 0 0.3rem;
			display: block;
		}
	}
}
.dialog-footer {
	position: absolute;
	bottom: 0;
	left: 0.6rem;
	right: 0.6rem;
	height: 1rem;
	z-index: 100;
	span {
		display: block;
		background-color: #122b31;
		width: 2.04rem;
		height: 1rem;
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 1rem;
		text-align: center;
		font-size: 0.28rem;
		color: #7badc2;
		&.active {
			background-color: #527686;
			color: #fff;
		}
		img {
			margin-right: 0.1rem;
		}
	}
}
</style>
